export const styles = () => ({
  footer: {
    gap: '12px'
  },
  archiveButton: {
    minWidth: 'auto',
    width: 'auto'
  }
});
